import React, { useState, useRef, useEffect, useMemo } from "react"
import { Formik, Field, Form } from "formik"
import moment from "moment"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    Wrapper,
    ActionSection,
    ScrollableContent,
    SideCancelBtn,
    CardWrapper,
    SelectionCard,
    Note,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose, MdEdit, MdOutlineInfo } from "react-icons/md"
import tw from "tailwind-styled-components"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import "react-dropdown/style.css"
import { FormControl } from "@mui/material"
import { useSelector } from "react-redux"
import SelectLocationModal from "../SelectLocationModal"


const EditPropertyName = ({
    setEditNameModel,
    selectedData,
    editNameLoading,
    editNameMutate,
    handleClose
}) => {
    const [showLocationModal, setShowLocationModal] = useState(false);
    const locations = useSelector((state) => state.LocationsReducer.locations);
    const filteredLocations = useMemo(() => {
        return locations?.filter(location => location.id !== 0) || [];
    }, [locations]);
    const formikRef = useRef(null)
    const [height, setHeight] = useState(window.innerHeight)
    const perfectFit = [
        { value: 1, label: "Male" },
        { value: 2, label: "Female" },
        { value: 3, label: "Both" },
    ];

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight)
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    const initialValues = {
        propertyName: selectedData?.name || "",
        perfectFit: selectedData?.tenantPreference || "",
        securityDeposit: selectedData?.security || "",
        agreementPeriod: selectedData?.agreementPeriod || "",
        noticePeriod: selectedData?.noticePeriod || "",
        lockInPeriod: selectedData?.lockInPeriod || "",
        id: selectedData?.id,
        locationId: selectedData?.locationId || "",
    };


    const handleSubmit = (values) => {
        const propertyNameRegex = /^[a-zA-Z0-9\-]+(?: [a-zA-Z0-9\-]+)*$/;
        const securityDepositRegex = /^\d{1,6}$/;
        const maxSecurityDeposit = 1000000;

        if (
            !values.perfectFit ||
            !values.lockInPeriod ||
            !values.noticePeriod ||
            !values.agreementPeriod
        ) {
            toast.error("All Fields are required");
            return;
        } if (
            !propertyNameRegex.test(values.propertyName.trim()) ||
            values.propertyName.trim().length < 5
        ) {
            toast.error(
                "Property Name should contain only alphabets, numbers, spaces, and dashes (-), and be at least 5 characters long"
            );
            return;
        }

        if (
            (values.securityDeposit &&
                !securityDepositRegex.test(values.securityDeposit)) ||
            parseInt(values.securityDeposit) > maxSecurityDeposit
        ) {
            toast.error(
                "Security deposit must be between 1 and 10,00,000 and contain only numbers"
            );
            return;
        }
        editNameMutate({
            name: values.propertyName,
            propId: selectedData?.id,
            tenantPreference: values.perfectFit,
            security: Number(values.securityDeposit || 0),
            agreementPeriod: values.agreementPeriod,
            noticePeriod: values.noticePeriod,
            lockInPeriod: values.lockInPeriod,
            locationId: values.locationId,
        });
    }




    return (
        <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
            <Header>
                <h1 className="text-lg font-medium text-white">Edit Property Details</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <div className="custom-scrollbar flex h-full flex-col justify-between px-6">

                <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit}>
                    {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => {
                        const getLocationLabel = () => {
                            const selectedRole = filteredLocations.find(
                                (role) => role.id === values?.locationId,
                            );
                            return selectedRole ? selectedRole.name : "Select Location";
                        };

                        const handleLocationSelect = (selectedValue) => {
                            setFieldValue("locationId", selectedValue);
                            setFieldValue("locationTouched", true);
                        };

                        return (
                            <Form>
                                <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                    <Wrapper>
                                        <InputGroup>
                                            <Label htmlFor="propertyName">Property Name *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="text"
                                                    name="propertyName"
                                                    id="propertyName"
                                                    autoComplete="off"
                                                    required
                                                />
                                            </FieldWrappers>
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="location">Select Location </Label>
                                            <FieldWrappers onClick={() => setShowLocationModal(true)}>
                                                <Field
                                                    type="text"
                                                    name="locationId"
                                                    id="locationId"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getLocationLabel()}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                />
                                                <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                                            </FieldWrappers>

                                            {touched.locationId && errors.locationId && (
                                                <p className="text-rose-600 text-sm mt-1">
                                                    {errors.locationId}
                                                </p>
                                            )}
                                        </InputGroup>
                                        <InputGroup>
                                            <Label>A Perfect Fit For *</Label>
                                            <CardWrapper>
                                                {perfectFit.map((mode) => (
                                                    <SelectionCard
                                                        key={mode.value}
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setFieldValue("perfectFit", mode.value);
                                                        }}
                                                        className={
                                                            values.perfectFit === mode.value
                                                                ? "bg-[#26A69A] text-white"
                                                                : "bg-gray-100 text-gray-800"
                                                        }
                                                    >
                                                        <span className="text-sm">{mode.label}</span>
                                                    </SelectionCard>
                                                ))}
                                            </CardWrapper>
                                            {touched.perfectFit && errors.perfectFit && (
                                                <p className="text-rose-600 text-sm">
                                                    {errors.perfectFit}
                                                </p>
                                            )}
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="securityDeposit">Security Deposit </Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="number"
                                                    name="securityDeposit"
                                                    id="securityDeposit"
                                                    autoComplete="off"
                                                />
                                            </FieldWrappers>
                                            {/* <Note>
                                                                                 <MdOutlineInfo className="mt-0.5 mr-1" />
                                                                                 This amount can be changed later
                                                                             </Note> */}
                                        </InputGroup>


                                        <InputGroup>
                                            <Label htmlFor="agreementPeriod">Agreement Period *</Label>
                                            <FormControl fullWidth>
                                                <Select
                                                    className="px-2"
                                                    id="agreementPeriod"
                                                    name="agreementPeriod"
                                                    value={values.agreementPeriod}
                                                    onChange={(e) =>
                                                        setFieldValue("agreementPeriod", e.target.value)
                                                    }
                                                    required
                                                    style={{ height: "46px" }}
                                                >
                                                    {Array.from({ length: 12 }, (_, i) => i + 1).map(
                                                        (month) => (
                                                            <MenuItem key={month} value={month}>
                                                                {month} {month === 1 ? "Month" : "Months"}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </InputGroup>

                                        {/* <CombineInputGroup> */}
                                        <InputGroup>
                                            <Label htmlFor="noticePeriod">Notice Period *</Label>
                                            <FormControl fullWidth>
                                                <Select
                                                    className="px-2"
                                                    id="noticePeriod"
                                                    name="noticePeriod"
                                                    value={values.noticePeriod}
                                                    onChange={(e) =>
                                                        setFieldValue("noticePeriod", e.target.value)
                                                    }
                                                    required
                                                    style={{ height: "46px" }}
                                                >
                                                    {Array.from({ length: 6 }, (_, i) => i + 1).map((month) => (
                                                        <MenuItem key={month} value={month}>
                                                            {month} {month === 1 ? "Month" : "Months"}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="lockInPeriod">Lock-In Period *</Label>
                                            <FormControl fullWidth>
                                                <Select
                                                    className="px-2"
                                                    id="lockInPeriod"
                                                    name="lockInPeriod"
                                                    value={values.lockInPeriod}
                                                    onChange={(e) =>
                                                        setFieldValue("lockInPeriod", e.target.value)
                                                    }
                                                    required
                                                    style={{ height: "46px" }}
                                                >
                                                    {Array.from({ length: 11 }, (_, i) => i + 1).map(
                                                        (month) => (
                                                            <MenuItem key={month} value={month}>
                                                                {month} {month === 1 ? "Month" : "Months"}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </InputGroup>
                                    </Wrapper>
                                </ScrollableContent>
                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={handleClose}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={editNameLoading}>
                                        {editNameLoading ? "Loading..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>
                                <SelectLocationModal
                                    isOpen={showLocationModal}
                                    onClose={() => setShowLocationModal(false)}
                                    options={filteredLocations}
                                    title="Select Location"
                                    selectedValue={values.locationId}
                                    onSelect={handleLocationSelect}
                                    searchPlaceholder="Search Location..."
                                />
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </Container>
    )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`
const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`
const FieldWrapper = tw.div`w-full`
const ExpenseDateRepetitionBtn = tw.button`
  flex items-center justify-center flex-col
  px-4 py-2
  text-sm font-medium text-gray-600
  bg-white 
  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
  disabled:opacity-50
`

export default EditPropertyName